// @ts-check
import { Component, ResourceManager } from "../engine";
import { EVENT_ENGINE_POST_START, LOGIC_GAME_INTRO, EVENT_GAME_PAUSE, EVENT_INGAME_KICKOFF, EVENT_INGAME_PLAYER_JUMPS, EVENT_INGAME_PLAYER_HITS_BALL, EVENT_INGAME_PLAYER_HITS_GROUND, EVENT_INGAME_BALL_HITS_GROUND, EVENT_INGAME_BALL_HITS_NET, EVENT_INGAME_SCORE_UPDATED, EVENT_INGAME_FOUL, EVENT_INGAME_HURRY_UP, EVENT_INGAME_TROPHY_ACHIEVED, EVENT_INGAME_EXPLOSION, LOG_TAG } from "../global";

export class GameSound extends Component {
    constructor(options) {
        super(options);

        this.soundSong = null;
        this.soundPlayerJumps = null;
        this.soundPlayerHitsBall = null;
        this.soundBallHitsGround = null;
        this.soundBallHitsNet = null;
        this.soundCheer = null;
        this.soundPlayerHitsGround = null;
        this.soundWhistle = null;
        this.soundPause = null;
        this.soundExplosion = null;
        this.soundHurry = null;
        this.soundTada = null;

        this.delayBallHitsNet = 0;
        this.delayPlayerHitsBall = 0;
    }

    update() {
        if (this.delayBallHitsNet > 0) {
            this.delayBallHitsNet--;
        }

        if (this.delayPlayerHitsBall > 0) {
            this.delayPlayerHitsBall--;
        }
    }

    handleEvent(event) {
        // Disabled sound
        if (this.options.enabled === false) {
            return;
        }

        // Init state
        const state = this.state;

        // Handle event
        switch (event.type) {
            case EVENT_ENGINE_POST_START:
                // Start music player
                if (state.logic == LOGIC_GAME_INTRO) {
                    this.playSound(this.soundSong, 0.4, 0);
                }

                break;
            case EVENT_GAME_PAUSE:
                this.playSound(this.soundPause);
                break;
            case EVENT_INGAME_KICKOFF:
                if (state.tutorial == null) {
                    this.stopSound(this.soundSong);
                }

                this.playSound(this.soundWhistle);
                break;
            case EVENT_INGAME_PLAYER_JUMPS:
                this.playSound(this.soundPlayerJumps);
                break;
            case EVENT_INGAME_PLAYER_HITS_BALL:
                if (this.delayPlayerHitsBall == 0 && (Math.abs(state.ball.velocity.y) > 5 || Math.abs(state.ball.velocity.x) > 5)) {
                    this.playSound(this.soundPlayerHitsBall);
                    this.delayPlayerHitsBall = 10;
                }

                break;
            case EVENT_INGAME_PLAYER_HITS_GROUND:
                this.playSound(this.soundPlayerHitsGround);
                break;
            case EVENT_INGAME_BALL_HITS_GROUND:
                if (Math.abs(state.ball.velocity.y) > 1 && !state.ball.sticky) {
                    this.playSound(this.soundBallHitsGround);
                }

                break;
            case EVENT_INGAME_BALL_HITS_NET:
                if (this.delayBallHitsNet == 0 && (Math.abs(state.ball.velocity.x) > 2 || Math.abs(state.ball.velocity.y) > 2)) {
                    this.playSound(this.soundBallHitsNet, 0.25);
                    this.delayBallHitsNet = 10;
                }

                break;
            case EVENT_INGAME_SCORE_UPDATED:
                this.playSound(this.soundCheer, 0.5, 0.1);
                this.playSound(this.soundWhistle);
                break;
            case EVENT_INGAME_FOUL:
                this.playSound(this.soundWhistle);
                break;
            case EVENT_INGAME_HURRY_UP:
                this.playSound(this.soundHurry);
                break;
            case EVENT_INGAME_TROPHY_ACHIEVED:
                this.playSound(this.soundTada, 0.5, 0);
                break;
            case EVENT_INGAME_EXPLOSION:
                this.playSound(this.soundExplosion);
                break;
        }
    }

    async init() {
        this.soundSong = this.loadSound("song4", { loop: true });
        this.soundPlayerHitsBall = this.loadSound("ball");
        this.soundPlayerHitsGround = this.loadSound("ground");
        this.soundPlayerJumps = this.loadSound("jump2");
        this.soundBallHitsGround = this.loadSound("pop");
        this.soundBallHitsNet = this.loadSound("boing2");
        this.soundCheer = this.loadSound("cheerapp2");
        this.soundWhistle = this.loadSound("whistle");
        this.soundPause = this.loadSound("dingdong2");
        this.soundHurry = this.loadSound("woobwoob");
        this.soundExplosion = this.loadSound("explosion");
        this.soundTada = this.loadSound("tada");
    }

    loadSound(id, options = {}) {
        return ResourceManager.sound(id, { ...this.options.howlerOptions, ...options });
    }

    playSound(resource, volume = 0.5, pitch = 0.2) {
        // sound.rate(1 + Math.random() * pitch);
        resource.value.volume(volume);
        resource.value.play();
    }

    stopSound(resource) {
        resource.value.stop();
    }
}
